var map = {
  "./assets/favicons-prodcan1/android-chrome-192x192.png": "792750",
  "./assets/favicons-prodcan1/android-chrome-512x512.png": "387374",
  "./assets/favicons-prodcan1/apple-touch-icon.png": "127201",
  "./assets/favicons-prodcan1/browserconfig.xml": "440885",
  "./assets/favicons-prodcan1/favicon-16x16.png": "406496",
  "./assets/favicons-prodcan1/favicon-32x32.png": "830652",
  "./assets/favicons-prodcan1/favicon-alert-16x16.png": "227409",
  "./assets/favicons-prodcan1/favicon-alert-32x32.png": "239121",
  "./assets/favicons-prodcan1/favicon-alert.ico": "575762",
  "./assets/favicons-prodcan1/favicon.ico": "300187",
  "./assets/favicons-prodcan1/mstile-150x150.png": "963090",
  "./assets/favicons-prodcan1/site.webmanifest": "175088",
  "./assets/favicons-prodcan1/upc-favicon.ico": "517446"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = () => (Object.keys(map));
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 45821;
